<template>
    <div class="knowledge-search">
        <a-input-search class="ipt" size="large" @onPressEnter="search" @search="search" v-model="keyword" />
        <div class="des">{{Common.description}}</div>
        <div class="btns">
            <a href="javascript:" class="reset" @click="reset">重置</a>
            <a href="javascript:" class="search" @click="search">检索</a>
            <!-- <router-link to="/result" class="search" @click="search">检索</router-link> -->
        </div>
    </div>
</template>

<script>
export default {
    props:{
        isResultSearch:{
            default:false
        }
    },
    data(){
        return {
            keyword: ''
        }
    },
    methods:{
        search(){ // 简单检索
            let simpleParams = {
                searchType: 1, 
                simpleKeyword: this.keyword
            }
            if(this.isResultSearch) this.$emit('knowledgeChange', simpleParams); // 列表页知识检索
            else this.$router.push({ name:"searchResult", params: simpleParams });
            // this.$router.push({path:"/result", query:{: JSON.stringify(searchParams)}});
        },
        reset(){ // 重置
            this.keyword = '';
        }
    }
}
</script>

<style scoped lang="less">
    .knowledge-search{
        padding: 70px 0;
        text-align: center;
        .des{
            color: #1473a5;
            line-height: 1.8;
            width: 330px;
            margin: 20px auto;
            font-size: 16px;
        }
        .ipt{
            background: #f7f8f8;
            border: 1px solid #666464;
            color: #666464;
            width: 510px;
            margin: 0 auto;
            border-radius: 20px;
            outline: none !important;
            overflow: hidden;
            /deep/ input{
                background: transparent;
                border: none !important;
                outline: none !important;
                padding-left: 20px;
            }
        }
    }
    /deep/ .ant-input-suffix{
        i{
            font-size: 22px;
        }
    }
</style>
